import comp from "./AIUsageLimit";
export default comp;
